import type { LifecycleStateLabel } from "@/api/projects";

/**
 * The one human spelling of each lifecycle label.
 *
 * Extracted from `run-state-badge.tsx`'s `STATE_META`, which owned it while the
 * badge was the only surface that said a state out loud. The lifecycle rail
 * (`run-lifecycle-rail.ts`) is the second, and it is a PURE module — it must be
 * able to name a stage without pulling framer-motion and lucide into its import
 * graph, and, more to the point, "staging inputs" reading as `staging_inputs`
 * in one place and "staging inputs" in the other is the drift a second copy
 * produces silently.
 *
 * The keys are the wire labels; the values are display text and nothing else.
 * Never map a wire label onto a DIFFERENT vocabulary here (INDEX.md invariant
 * #3, never invent a run-state string): this substitutes an underscore for a
 * space and expands nothing.
 */
export const STATE_LABEL: Record<LifecycleStateLabel, string> = {
  validating: "validating",
  cached: "cached",
  staging_inputs: "staging inputs",
  dispatched: "dispatched",
  running: "running",
  collecting_outputs: "collecting outputs",
  validating_outputs: "validating outputs",
  completed: "completed",
  failed_validation: "failed validation",
  failed_system: "failed system",
  failed_scientific: "failed scientific",
  failed_contract: "failed contract",
};
